"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTemplate = void 0;
var ContentTemplate_component_1 = require("./ContentTemplate.component");
Object.defineProperty(exports, "ContentTemplate", { enumerable: true, get: function () { return __importDefault(ContentTemplate_component_1).default; } });
